import React from 'react';
export default ({ href, className, children }) => {
  return (
    <a href={href} className={className} target="_blank" rel="noopener noreferrer">
      {children ? children : href}
    </a>
  );
};
